import React from 'react';
import PropTypes from 'prop-types';

import Image from '../../library/image/image';

import './group-affiliation-promotion-id-me-button.scss';

function GroupAffiliationPromotionIdMeButton(props) {
  const { isAppliedPromotion, openVerificationWindow } = props;

  return (
    <>
      {!isAppliedPromotion && (
        <button
          className="group-affiliation-promotion-id-me-button"
          onClick={openVerificationWindow}
        >
          <Image
            alt="ID.me Logo"
            height="40"
            loading="lazy"
            src="/images/idme-button.svg"
            styleName="logo"
            width="218"
          />
        </button>
      )}
    </>
  );
}

GroupAffiliationPromotionIdMeButton.propTypes = {
  isAppliedPromotion: PropTypes.bool,
  openVerificationWindow: PropTypes.func
};

export default GroupAffiliationPromotionIdMeButton;
